import React from 'react';
import PropTypes from 'prop-types';

function StickyProgressBar({className, widthInPercent}) {

    return (
        <div className={`row sticky-progress-bar ${className}`}>
            <div className="progress-amount" style={{width: `${widthInPercent}%`}}></div>
            <div className="progress-after"></div>
        </div>
    );
}

StickyProgressBar.defaultProps = {
    widthInPercent: 100
}

StickyProgressBar.propTypes = {
    widthInPercent: PropTypes.number,
}

export default StickyProgressBar;

